export const updateBodyClass = (to) => {
    document.body.classList = to.page.body.classList
}